// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__139L1","footer":"Form_footer__CHPPD"};